import { Client } from '@microsoft/microsoft-graph-client';
import { AuthCodeMSALBrowserAuthenticationProvider } from '@microsoft/microsoft-graph-client/authProviders/authCodeMsalBrowser';
import { getMSALInstance } from '@/components/ms-teams/MSAL';

export const getGraphClient = providerOptions => {
  const authProvider = new AuthCodeMSALBrowserAuthenticationProvider(getMSALInstance(), providerOptions);
  return Client.initWithMiddleware({ authProvider });
};
